import { FormEventPayload } from 'shared-code/app-events'
import { PostContext } from '../contexts/PostContext'
import { AppEventsContext } from '../contexts/AppEventsContext'

interface UseFormAppEventsResult {
  formSuccessEvent: (payload: FormEventPayload) => void
  formFailureEvent: (payload: FormEventPayload) => void
  formStartedEvent: (payload: FormEventPayload) => void
}

export function useFormAppEvents(): UseFormAppEventsResult {
  const postMeta = PostContext.useContainer()
  const { appEvent } = AppEventsContext.useContainer()

  return {
    formSuccessEvent: payload => {
      appEvent({
        event: 'form-success',
        payload,
        postMeta,
        url: window.location.href,
      })
    },
    formFailureEvent: payload => {
      appEvent({
        event: 'form-failure',
        payload,
        postMeta,
        url: window.location.href,
      })
    },
    formStartedEvent: payload => {
      appEvent({
        event: 'form-started',
        payload,
        postMeta,
        url: window.location.href,
      })
    },
  }
}
